// Giovanni Triana / HOUSEITGOING LLC site configuration.
// Anything that changes from one client site to another belongs in this file.
const GIOVANNI_LANDING_VIDEO = 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/giovanni.atl-landing-001.mp4';

export const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 'giovanni.atl',
  LISTING_PREVIEWS_ENABLED: true,
  ANALYTICS: {
    GA4_MEASUREMENT_ID: 'G-G3P7GJGB16'
  },
  BASE_URL: 'casasenatlanta.com',
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=4665c5a2-a9c2-4dbf-acf6-92be1ae9f771&token=Eo8hXKWIfQ46lmY1YCV55lCTh1Zh8ivE9Ki5OVOUg8&operation=startbuild',
  SENDER_EMAIL_ENCRYPTION_KEY: 'ddc32d25f6877ce7692b7361fe9c3cfa75c8fedc8ddbfb6529a636b950fd11bf',
  STATE: 'GA',
  SEARCH_STATES: ['GA'],
  DEFAULT_LANGUAGE: 'es',
  AGENT: {
    MLS_ID: 'TRIANA',
    NAME: 'Giovanni Triana',
    FIRST_NAME: 'Giovanni',
    BROKERAGE: 'HOUSEITGOING LLC',
    OFFICE_ID: 'HITG01',
    OFFICE_KEYS: ['50513308'],
    OFFICE_CITY: 'Peachtree Corners',
    OFFICE_ADDRESS: '5425 Peachtree Pkwy, Peachtree Corners, GA 30092',
    EMAIL: 'giovannitriana@gmail.com',
    PHONE: '+1-770-256-0463',
    OFFICE_PHONE: '+1-678-680-8625',
    ZILLOW_REVIEW: 'https://www.zillow.com/profile/Giovanni%20Triana#reviews',
    GOOGLE_REVIEW: '',
    BROKERAGE_LICENSE: '50513308',
    LICENSE: '221561',
    YEARS_EXPERIENCE: 26,
    LANGUAGES: ['English', 'Spanish', 'Portuguese']
  },
  TEAM: {
    MONICA: {
      NAME: 'Monica Triana',
      PHONE: '+1-678-353-9185'
    }
  },
  SERVICE_AREAS: [
    'Atlanta', 'Norcross', 'Peachtree Corners', 'Lawrenceville', 'Suwanee',
    'Alpharetta', 'Duluth', 'Snellville', 'Buford', 'Johns Creek'
  ],
  LANDING_PAGE: {
    ICONS: {
      MOON: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-moon.png',
      SUN: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-sun.png',
      BLOGS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-blogs.png',
      REVIEWS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-reviews.png',
      SEARCH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-globe.png',
      AGENT: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-agent.png',
      ACCOUNT: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-account.png',
      ADMIN: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-admin.png'
    },
    VIDEOS: {
      HERO: GIOVANNI_LANDING_VIDEO,
      DESKTOP: GIOVANNI_LANDING_VIDEO,
      TABLET: GIOVANNI_LANDING_VIDEO,
      MOBILE: GIOVANNI_LANDING_VIDEO,
      HOME_VALUE: GIOVANNI_LANDING_VIDEO
    },
    EDITORIAL_IMAGES: {
      LIVING_ROOM: '/giovanni-family.png',
      CONDO_INTERIOR: '/giovanni-headshot.png'
    },
    AGENT_IMAGE: '/giovanni-headshot.png',
    FAMILY_IMAGE: '/giovanni-family.png',
    CITY_IMAGES: {
      ATLANTA: '/giovanni-family.png',
      NORCROSS: '/giovanni-headshot.png',
      PEACHTREE_CORNERS: '/giovanni-family.png',
      LAWRENCEVILLE: '/giovanni-headshot.png',
      SUWANEE: '/giovanni-family.png',
      ALPHARETTA: '/giovanni-headshot.png'
    },
    FOOTER_LOGO: 'https://aw-business-marketing.s3.us-east-1.amazonaws.com/websitesbyaw-transparent.png'
  },
  MLS: {
    NAME: 'First Multiple Listing Service of Atlanta, Inc.',
    SHORT_NAME: 'FMLS',
    LOGO_URL: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/fmlslogo.png',
    DISCLAIMER_PREVIEW: 'Information Deemed Reliable But Not Guaranteed.',
    DISCLAIMER_DETAIL: 'Listings on this website come from the FMLS IDX Compilation and may be held by brokerage firms other than the owner of this website. The listing brokerage is identified in any listing details. Information is deemed reliable but is not guaranteed.',
    DMCA_URL: 'https://www.fmls.com/dmca/'
  },
  MLS_BY_STATE: {
    GA: {
      NAME: 'First Multiple Listing Service of Atlanta, Inc.',
      SHORT_NAME: 'FMLS',
      LOGO_URL: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/fmlslogo.png',
      DISCLAIMER_PREVIEW: 'Information Deemed Reliable But Not Guaranteed.',
      DISCLAIMER_DETAIL: 'Listings on this website come from the FMLS IDX Compilation and may be held by brokerage firms other than the owner of this website. The listing brokerage is identified in any listing details. Information is deemed reliable but is not guaranteed.',
      DMCA_URL: 'https://www.fmls.com/dmca/'
    }
  }
};

export const mlsForState = (state) => SITE_CONFIG.MLS_BY_STATE[state] || SITE_CONFIG.MLS;

export const SEO_CONFIG = {
  AGENT_NAME: SITE_CONFIG.AGENT.NAME,
  AGENT_EMAIL: SITE_CONFIG.AGENT.EMAIL,
  AGENT_PHONE: SITE_CONFIG.AGENT.PHONE,
  STREET_ADDRESS: '5425 Peachtree Pkwy',
  CITY: 'Peachtree Corners',
  STATE: SITE_CONFIG.STATE,
  ZIP_CODE: '30092',
  COUNTRY: 'US',
  LATITUDE: '',
  LONGITUDE: '',
  DOMAIN: 'casasenatlanta.com',
  FACEBOOK_URL: '',
  INSTAGRAM_URL: '',
  TWITTER_HANDLE: '',
  LINKEDIN_URL: '',
  ZILLOW_URL: SITE_CONFIG.AGENT.ZILLOW_REVIEW,
  OG_IMAGE: 'https://casasenatlanta.com/giovanni-family.png',
  TWITTER_IMAGE: 'https://casasenatlanta.com/giovanni-family.png',
  LOGO_URL: 'https://casasenatlanta.com/giovanni-headshot.png'
};
